import { post } from 'common/utils/xhr';
import { get as getCookie } from 'cookies-js';

type Error = {
    param: string;
    message: string;
};

export function login(email: string, password: string) {
    return authenticateLogin(email, password);
}

function authenticateLogin(email: string, password: string) {
    const xhr = post('/accounts/xhr/login', {
        email: email,
        password: password,
        csrf_token: getCookie('_99csrf'),
    });

    return new Promise((resolve, reject) => {
        xhr.end((err, res) => {
            if (err) {
                if (res.status !== 400) {
                    reject(null);
                }

                const errors: { [key: string]: string } = {};
                const json = JSON.parse(res.text) as { errors: Error[] };

                if (json.errors) {
                    json.errors.forEach(error => (errors[error.param] = error.message));
                }
                reject(errors);
            } else {
                resolve(res.body);
            }
        });
    });
}

type Signup = {
    email: string;
    password: string;
    source?: string;
    hasAgreedToPrivacyAndTerms: boolean;
};

export function signup({ email, password, source, hasAgreedToPrivacyAndTerms }: Signup) {
    const xhr = post('/accounts/xhr/signup', {
        email: email,
        password: password,
        role: '',
        displayname: '',
        csrf_token: getCookie('_99csrf'),
        source: source,
        legals: hasAgreedToPrivacyAndTerms,
    });

    return new Promise((resolve, reject) => {
        xhr.end((err, res) => {
            if (err) {
                if (res.status !== 400) {
                    reject(null);
                }

                const errors: { [key: string]: string } = {};
                const json = JSON.parse(res.text) as { errors: Error[] };

                json.errors.forEach(error => (errors[error.param] = error.message));
                reject(errors);
            } else {
                resolve(res.body);
            }
        });
    });
}
